export default "__VITE_ASSET__B4c_IP4J__"